(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-banner')) {
    customElements.define(
      'hero-banner',
      class HeroBanner extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;

          this.slides = Array.from(this.track.querySelectorAll('[data-slide]'));
          this.refs = Array.from(this.querySelectorAll('[data-ref]'));
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.prevBtn = this.querySelector('[data-prev]');
          this.nextBtn = this.querySelector('[data-next]');
          this.count = this.slides.length;
          this.loop = this.count > 1;
          this.index = 0; // logical slide (0..count-1)
          this.pos = 0; // position in the track (clones included)
          this.drag = null;
          this.timer = null;
          this.fallback = null;
          this.animating = false;
          this.hoverPaused = false;
          this.editorPaused = false;
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.delay = (parseInt(this.dataset.delay, 10) || 5) * 1000;
          this.autoplay = this.dataset.autoplay === 'true' && this.loop && !this.reduced;

          // Infinite loop: clone the last slide before the first and the first after the last
          if (this.loop) {
            this.track.insertBefore(this.makeClone(this.slides[this.count - 1]), this.slides[0]);
            this.track.appendChild(this.makeClone(this.slides[0]));
            this.jump(1);
          }
          this.all = Array.from(this.track.children);

          this.onVisibility = () => this.schedule();
          document.addEventListener('visibilitychange', this.onVisibility);

          this.track.addEventListener('transitionend', (e) => {
            if (e.target === this.track && e.propertyName === 'transform') this.settle();
          });

          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());
          this.dots.forEach((dot, n) => dot.addEventListener('click', () => this.goTo(n)));

          // Swipe / drag on the moving backgrounds
          this.track.addEventListener('pointerdown', (e) => this.onDown(e));
          this.track.addEventListener('pointermove', (e) => this.onMove(e));
          this.track.addEventListener('pointerup', (e) => this.onUp(e));
          this.track.addEventListener('pointercancel', (e) => this.onUp(e));

          // Pause autoplay on hover / focus
          this.addEventListener('mouseenter', () => {
            this.hoverPaused = true;
            this.clear();
          });
          this.addEventListener('mouseleave', () => {
            this.hoverPaused = false;
            this.schedule();
          });
          this.addEventListener('focusin', () => {
            this.hoverPaused = true;
            this.clear();
          });
          this.addEventListener('focusout', () => {
            this.hoverPaused = false;
            this.schedule();
          });

          // Theme editor: show the slide of the selected block
          this.addEventListener('shopify:block:select', (event) => {
            const n = this.slides.indexOf(event.target.closest('[data-slide]'));
            this.editorPaused = true;
            this.clear();
            if (n > -1) {
              this.animating = false;
              this.goTo(n);
            }
          });
          this.addEventListener('shopify:block:deselect', () => {
            this.editorPaused = false;
            this.schedule();
          });

          this.syncVideos();
          this.schedule();
        }

        disconnectedCallback() {
          this.clear();
          clearTimeout(this.fallback);
          document.removeEventListener('visibilitychange', this.onVisibility);
        }

        makeClone(slide) {
          const clone = slide.cloneNode(true);
          ['data-slide', 'data-shopify-editor-block', 'role', 'aria-label'].forEach((a) => clone.removeAttribute(a));
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          clone.querySelectorAll('img').forEach((img) => {
            img.loading = 'eager';
            img.removeAttribute('fetchpriority');
          });
          clone.querySelectorAll('iframe').forEach((frame) => (frame.loading = 'eager'));
          return clone;
        }

        // Place the track at a position instantly (no animation)
        jump(pos) {
          this.pos = pos;
          this.track.classList.add('is-jumping');
          this.track.style.setProperty('--i', pos);
          this.track.style.setProperty('--drag', '0px');
          void this.track.offsetWidth;
          this.track.classList.remove('is-jumping');
        }

        // Called when a slide animation ends: silently swap clones for the real slides
        settle() {
          clearTimeout(this.fallback);
          if (this.loop) {
            if (this.pos === 0) this.jump(this.count);
            else if (this.pos === this.count + 1) this.jump(1);
          }
          this.animating = false;
          this.syncVideos();
          this.schedule();
        }

        move(index, pos, dir) {
          if (this.animating || !this.loop) return;
          this.animating = true;
          const prev = this.index;
          this.index = index;
          this.pos = pos;

          this.track.style.setProperty('--i', pos);
          this.updateText(prev, dir);
          this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === index ? 'true' : 'false'));
          this.syncVideos();
          this.clear();

          clearTimeout(this.fallback);
          this.fallback = setTimeout(() => this.settle(), this.reduced ? 60 : 1100);
        }

        next() {
          this.move((this.index + 1) % this.count, this.pos + 1, 1);
        }

        prev() {
          this.move((this.index - 1 + this.count) % this.count, this.pos - 1, -1);
        }

        goTo(n) {
          if (n === this.index) return;
          this.move(n, n + 1, n > this.index ? 1 : -1);
        }

        // Animated text swap: outgoing leaves in the direction of travel, incoming arrives from the opposite side
        updateText(prev, dir) {
          const idx = this.index;

          // Park the incoming text on the correct side (instantly, while invisible)
          this.refs.forEach((el) => {
            if (Number(el.dataset.ref) !== idx) return;
            el.style.transition = 'none';
            el.classList.remove('is-active');
            el.classList.toggle('is-before', dir < 0);
          });
          void this.track.offsetWidth;

          this.refs.forEach((el) => {
            const r = Number(el.dataset.ref);
            const active = r === idx;
            el.style.transition = '';
            el.classList.toggle('is-active', active);
            if (!active && r === prev) el.classList.toggle('is-before', dir > 0);
            el.setAttribute('aria-hidden', active ? 'false' : 'true');
            if (el.tagName === 'A') el.tabIndex = active ? 0 : -1;
          });
        }

        syncVideos() {
          if (!this.all) return;
          this.all.forEach((slide, p) => {
            slide.querySelectorAll('video').forEach((video) => {
              video.muted = true;
              video.playsInline = true;
              if (p === this.pos) {
                const played = video.play();
                if (played && played.catch) played.catch(() => {});
              } else {
                video.pause();
              }
            });
          });
        }

        clear() {
          clearTimeout(this.timer);
        }

        schedule() {
          this.clear();
          if (!this.autoplay || this.hoverPaused || this.editorPaused || document.hidden) return;
          this.timer = setTimeout(() => this.next(), this.delay);
        }

        onDown(e) {
          if (!this.loop || this.animating) return;
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          this.drag = { id: e.pointerId, x: e.clientX, raw: 0, moved: false };
        }

        onMove(e) {
          const d = this.drag;
          if (!d || e.pointerId !== d.id) return;

          const dx = e.clientX - d.x;
          if (!d.moved) {
            if (Math.abs(dx) < 6) return;
            d.moved = true;
            try {
              this.track.setPointerCapture(d.id);
            } catch (err) {}
            this.track.classList.add('is-dragging');
            this.clear();
          }

          d.raw = dx;
          this.track.style.setProperty('--drag', dx + 'px');
        }

        onUp(e) {
          const d = this.drag;
          this.drag = null;
          if (!d || !d.moved) return;

          try {
            this.track.releasePointerCapture(d.id);
          } catch (err) {}

          this.track.classList.remove('is-dragging');
          this.track.style.setProperty('--drag', '0px');

          const threshold = Math.min(90, this.track.clientWidth * 0.15);
          if (d.raw < -threshold) this.next();
          else if (d.raw > threshold) this.prev();
          else this.schedule();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
